$(document).ready(function() {
	//------------------------------------------
	// Bouton menu
	//------------------------------------------
	var jBtn = $('.button--menu'),
	jMenu = $('.Menu'),
	jClose = $('.Menu-close'),
	jTitleMenu = $('.Menu .s-title2'),
	jMenuItem = $('.Menu li a'),
	jLang = $('.Navigation-actions'),
	jMentions = $('.Navigation-mentions'),
	isActive = false,
	jBody = $('body'),
	jOverlay = $('.Menu-overlay')
	;

	jBtn.click(function() {
		if(!isActive){
			isActive = true;
			$(this).toggleClass('isActive');
			if($(this).hasClass('isActive')){
				openMenu();
			}else{
				closeMenu();
			}
		}
		return false;
	});

	jOverlay.click(function(){
		jBtn.removeClass('isActive');
		closeMenu();
	});

	function openMenu(){
		jBody.css('overflow-y','hidden');
		const tl = new TimelineLite({
			onComplete:()=>{isActive = false;}
		})

		.set(jOverlay,{display:'block'})
		.to(jMenu,.5,{className:'+=isActive'})
		.to(jLang,0.5,{x:50,autoAlpha:0,force3D:true,ease:Power4.easeOut,display:'none'},0)
		.fromTo(jMentions,0.5,{x:50,autoAlpha:0},{x:0,autoAlpha:1,ease:Power4.easeOut,display:'inline-block'})
		.staggerTo(jMenuItem,.6,{className:'+=isActive',ease:Power4.easeOut},0.08,.2)
	}

	function closeMenu(){
		jBody.css('overflow-y','visible');
		const tl = new TimelineLite({
			onComplete:()=>{isActive = false;}
		})
		.set(jOverlay,{display:'none'})
		.staggerTo(jMenuItem,.6,{className:'-=isActive',ease:Power4.easeOut},0.08)
		.to(jMentions,.5,{x:50,autoAlpha:0,force3D:false,ease:Power4.easeOut,display:'none'},0)
		.to(jMenu,.5,{className:'-=isActive'},.2)
		.to(jLang,.5,{x:0,autoAlpha:1,ease:Power4.easeOut,display:'inline-block'},'-=.3')
	}



	for(let i=0; i<7; i++){
			let w = 100/i;
	}
	var lineMaker = new LineMaker({
					// position: if fixed the lines container will have fixed position.
					position: 'fixed',
					// The lines settings:
					//
					// top, left, width, height: numerical for pixels or string for % and viewport units. Examples: 2 || '20%' || '50vw'.
					// color: the (bg)color of the line.
					// hidden: defines if the line is rendered initially or hidden by default.
					// animation: animation properties for the line
					// 		duration: animation speed.
					// 		easing: animation easing (animejs easing. To see all possible values console animejs.easings).
					// 		delay: animation delay.
					// 		direction: line animation direction. Possible values: TopBottom || BottomTop || LeftRight || RightLeft || CenterV || CenterH.
					lines: [
						{top: 0, left: '0%', width: 1, height: '100vh', color: '#f2f2f2', hidden:true, opacity:0.2, animation: { duration: 2000, easing: 'easeInOutExpo', delay: 0, direction: 'TopBottom' }},
						{top: 0, left: '12.5%', width: 1, height: '100vh', color: '#f2f2f2', hidden:true, opacity:0.2, animation: { duration: 2000, easing: 'easeInOutExpo', delay: 0, direction: 'TopBottom' }},
						{top: 0, left: '25%', width: 1, height: '100vh', color: '#f2f2f2', hidden:true, opacity:0.2, animation: { duration: 2000, easing: 'easeInOutExpo', delay: 0, direction: 'TopBottom' }},
						{top: 0, left: '37.5%', width: 1, height: '100vh', color: '#f2f2f2', hidden:true, opacity:0.2, animation: { duration: 2000, easing: 'easeInOutExpo', delay: 0, direction: 'TopBottom' }},
						{top: 0, left: '50%', width: 1, height: '100vh', color: '#f2f2f2', hidden:true, opacity:0.2, animation: { duration: 2000, easing: 'easeInOutExpo', delay: 0, direction: 'TopBottom' }},
						{top: 0, left: '62.5%', width: 1, height: '100vh', color: '#f2f2f2', hidden:true, opacity:0.2, animation: { duration: 2000, easing: 'easeInOutExpo', delay: 0, direction: 'TopBottom' }},
						{top: 0, left: '75%', width: 1, height: '100vh', color: '#f2f2f2', hidden:true, opacity:0.2, animation: { duration: 2000, easing: 'easeInOutExpo', delay: 0, direction: 'TopBottom' }},
						{top: 0, left: '87.5%', width: 1, height: '100vh', color: '#f2f2f2', hidden:true, opacity:0.2, animation: { duration: 2000, easing: 'easeInOutExpo', delay: 0, direction: 'TopBottom' }},
						{top: 0, left: '100%', width: 1, height: '100vh', color: '#f2f2f2', hidden:true, opacity:0.2, animation: { duration: 2000, easing: 'easeInOutExpo', delay: 0, direction: 'TopBottom' }},
					]
			});

			lineMaker.animateLinesIn();


	//------------------------------------------
	// Skip links
	//------------------------------------------
	var jSkip = $('#skip-link'),
	jLinks = $('a', jSkip)
	;

	jLinks.blur(function(){
		jSkip.removeClass('focus');
	})
	.focus(function() {
		jSkip.addClass('focus');
	});



	//------------------------------------------
	// Dotdotdot / Cut des textes trop longs avec "..."
	//------------------------------------------

	$('.dotdotdot').dotdotdot({
		ellipsis	: '...',
		wrap		: 'letter',
		fallbackToLetter: true,
		watch		: true,
		tolerance	: 0,
		callback	: function( isTruncated, orgContent ) {},
		lastCharacter	: {
			remove		: [ ' ', ',', ';', '.', '!', '?' ],
			noEllipsis	: []
		}
	});


	$('.Navigation .button--up').click(function(){
		TweenLite.to(window, 1, {scrollTo:0,ease:Power4.easeOut});
		return false;
	})

	$('.Cover .button--up').click(function(){
		TweenLite.to(window, 1, {scrollTo:$(window).height(),ease:Power4.easeOut});
		return false;
	})


	// if($('.Cover').length){
	// 	  var scroll,
	// 		  targetScroll = 0,
	// 		  currentScroll = 0,
	// 		  jparalax = $('.parallax'),
	// 		  jDocument = $(document),
	// 		  $h = $('.Cover img').height(),
	// 		  $this = this
	// 	  ;
	//
	// 	  let 	opacityMin = ($('.Cover--projets').length) ? 0.3 : 0.1,
	// 	  		opacityRatio = 0,
	// 	   		opacityMax = 0.8,
	// 			scrollMin = 0,
	// 			scrollMax = $(window).height(),
	// 			scrollRatio = 0,
	// 			filterGrey =  ($('.Cover--projets').length) ? opacityRatio : scrollRatio
	// 	 ;
	//
	// 	  // parallax //
	// 	  $(document).scroll(function(e) {
	// 		  scroll = $(this).scrollTop();
	//
	// 		   scrollRatio = scroll/scrollMax,
	// 		   opacityRatio = opacityMax - (opacityMax/(opacityMax - opacityMin) * scrollRatio);
	//
	// 			if(opacityRatio < 0.1){
	// 				opacityRatio = 0.1;
	// 			}else if(opacityRatio > 1){
	// 				opacityRatio = opacityMax;
	// 			}
	//
	// 			console.log(opacityRatio);
	// 			let percent = filterGrey*100;
	// 			// $('.Cover-img img').css({'filter':`grayscale(${percent*2}%)`});
	//
	// 			console.log(scrollRatio);
	// 			console.log(opacityRatio);
	// 			console.log(filterGrey);
	// 			$('.Cover img').css({
	// 				'opacity': opacityRatio,
	// 				'filter':`grayscale(${percent*2}%)`
	// 		 	});
	// 	  });
	//   }





});
